import axios from './axiosConfig'

export const getInsightCount = async () => {
  const response = await axios.get(`/dashboard`)
  console.log('response count', response.data)
  return response.data
}

export const validateCin = async (cinNumber) => {
  try {
    const response = await axios.get(`/dashboard/cin/${cinNumber}`)
    console.log('CIN validation response:', response.data)
    return response.data
  } catch (error) {
    console.error(
      'Error validating CIN:',
      error.response?.data || error.message
    )
    throw error
  }
}
